import React, { useRef, useEffect } from 'react';

import { I18n } from 'react-redux-i18n';

import cargoTruck from './cargoTruck.png';

function TruckLoadChartCanvas({ pendingQty, finishedQty, isGeneral }) {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const container = containerRef.current;
    const ctx = canvas.getContext('2d');
    const image = new Image();

    image.src = cargoTruck;

    const resizeCanvas = () => {
      const { width } = container.getBoundingClientRect(); // Largura dinâmica do grid
      const aspectRatio = image.width / image.height;

      canvas.width = width;
      canvas.height = width / aspectRatio;

      // Redesenha a imagem ajustada ao tamanho do canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

      // Total para preencher o baú é 202
      const perc = 202;
      const totalQty = pendingQty + finishedQty;
      const percFinished = Math.round((finishedQty / totalQty) * 100);
      const cargoPercentage = Math.round((percFinished / 100) * perc);

      let cargoColor = 'transparent';

      if (percFinished >= 0 && percFinished < 50) {
        cargoColor = 'red';
      } else if (percFinished >= 0 && percFinished < 90) {
        cargoColor = 'yellow';
      } else if (percFinished >= 90 && percFinished <= 100) {
        cargoColor = 'green';
      }

      if (isGeneral) {
        cargoColor = 'transparent';
      }

      ctx.fillStyle = cargoColor;
      ctx.fillRect(15, 18, cargoPercentage, 57); // A carga dentro do baú

      ctx.fillStyle = 'black';
      ctx.font = '25px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(Number.isNaN(percFinished) ? `${0}%` : `${percFinished}%`, 120, 40); // Texto no centro do baú

      ctx.fillStyle = 'black';
      ctx.font = '15px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(I18n.t('BEE4186', { 0: finishedQty, 1: totalQty } /* Finalizados %{0} de %{1} */), 120, 65); // Texto no centro do baú
    };

    image.onload = () => {
      resizeCanvas();

      // Ajusta o canvas dinamicamente ao redimensionar
      window.addEventListener('resize', resizeCanvas);
    };

    return () => {
      window.removeEventListener('resize', resizeCanvas);
    };
  }, [pendingQty, finishedQty, isGeneral]);

  return (
    <div ref={containerRef} style={{ width: '100%', maxWidth: '400px', margin: '0 auto' }}>
      <canvas ref={canvasRef} style={{ display: 'block', width: '100%', height: 'auto' }} />
    </div>
  );
}

export default TruckLoadChartCanvas;
